import update from "immutability-helper";

import {
  ONE_ORGANIZATION_LOADED,
  ONE_ORGANIZATION_UPDATED,
  ORGANIZATIONS_LOADED,
  ORGANIZATIONS_LOADING,
  ORGANIZATION_RESET_USERS,
} from "../actions/types";

export interface Organization {
  _id: string;
  activity: boolean;
  local_recordings_allowed: boolean;
  local_recordings_polyfill: boolean;
  maxProjectsAllowed: number;
  org_manager_view_all: boolean;
  backgroundUrl: string;
  projects: number;
  recording_hours: number;
  organizational_code: string;
  organization_name: string;
  require_session_passwords: boolean;
  aviary_export_allowed: boolean;
  permanent_org?: {
    export_allowed: boolean;
    archive_nbr: string;
  };
  allow_dial_in: boolean;
  credits?: number;
  created_at: string;

  users?: any;
}

export interface OrganizationsState {
  organizations: { [key: string]: Organization };
  users: any[];
  loading: boolean;
}

interface OrganizationsAction {
  type: string;
  payload: any;
}

const initialState: OrganizationsState = {
  organizations: {},
  users: [],
  loading: false,
};
// groups reducer
const organizationsReducer = (state = initialState, action: OrganizationsAction): OrganizationsState => {
  switch (action.type) {
    // loads groups
    case ORGANIZATIONS_LOADING: {
      return update(state, {
        loading: { $set: true },
      });
    }

    case ORGANIZATIONS_LOADED: {
      return update(state, {
        loading: { $set: false },
        organizations: { $set: Object.fromEntries(action.payload.map((org) => [org.organizational_code, org])) },
      });
    }

    case ONE_ORGANIZATION_LOADED: {
      const updateParams: any = {
        loading: { $set: false },
        organizations: {
          [action.payload.organization.organizational_code]: {
            $set: action.payload.organization,
          },
        },
      };
      if (action.payload.users) {
        updateParams.users = { $set: action.payload.users };
      }
      return update(state, updateParams);
    }

    case ONE_ORGANIZATION_UPDATED: {
      const orgCode = action.payload.organizationalCode;
      return update(state, {
        organizations: {
          [orgCode]: { $merge: action.payload.values },
        },
      });
    }

    case ORGANIZATION_RESET_USERS: {
      return update(state, {
        users: { $set: initialState.users },
      });
    }

    default:
      return state;
  }
};

export default organizationsReducer;
